module.exports = __webpack_public_path__ + "img/logo.f29cfe17.png";